import _asyncToGenerator from "/home/runner/work/integracao-custos/integracao-custos/frontend/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/integracao-custos/integracao-custos/frontend/app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/home/runner/work/integracao-custos/integracao-custos/frontend/app/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _defineProperty from "/home/runner/work/integracao-custos/integracao-custos/frontend/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import _regeneratorRuntime from "/home/runner/work/integracao-custos/integracao-custos/frontend/app/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import Vue from "vue";
import jwt_decode from "jwt-decode";
import Notifier from "./notifyService";
import UserPermissionsService from "../services/userPermissions.service";
var AuthService = /*#__PURE__*/function () {
  function AuthService() {
    _classCallCheck(this, AuthService);
    _defineProperty(this, "clientIdAndSecret", btoa("client:secret"));
  }
  return _createClass(AuthService, [{
    key: "login",
    value: function login(user) {
      var formData = new FormData();
      formData.append('username', user.username.toUpperCase());
      formData.append('password', user.password);
      formData.append('grant_type', 'password');
      return Vue.prototype.$axios.post('/oauth/token', formData, {
        headers: {
          Authorization: 'Basic ' + this.clientIdAndSecret
        }
      }).then(function (response) {
        if (!response.data || !response.data.access_token) {
          // Status 2xx but missing the expected access_token — happens when the request
          // hit the nginx SPA fallback (index.html as 200 OK body) because the frontend
          // baseURL ended up empty. Without throwing, loginSuccess commits garbage and
          // the user is bounced silently. Throw so the .catch shows a friendly message.
          throw new Error('Resposta de autenticação inválida');
        }
        var token = response.data.access_token;
        var decoded = jwt_decode(token);
        localStorage.setItem('token', token);
        localStorage.setItem('custCenter', decoded.custCenter);
        localStorage.setItem('authorities', JSON.stringify(decoded.authorities));
        localStorage.setItem('user_name', decoded.user_name);
        return response.data;
      }).catch(function (e) {
        var notifier = new Notifier();
        var status = e.response && e.response.status;
        if (status === 401) {
          notifier.error("Usuário ou senha inválidos.");
        } else if (!e.response) {
          notifier.error("Não foi possível efetuar o login. Verifique se o usuário existe e se o servidor está disponível.");
        } else {
          notifier.error("Favor verificar junto ao Administrador do Sistema, a redefinição da senha de login para usuário informado.");
        }
        throw e;
      });
    }
  }, {
    key: "hasAuthority",
    value: function hasAuthority(authority) {
      var authorities = JSON.parse(localStorage.getItem("authorities"));
      return authorities && (authorities.includes(authority) || authorities.includes('ROLE_ADMINISTRADOR_DO_SISTEMA'));
    }
  }, {
    key: "getCenterCust",
    value: function getCenterCust() {
      return JSON.parse(localStorage.getItem("custCenter"));
    }
  }, {
    key: "getUserName",
    value: function getUserName() {
      return localStorage.getItem("user_name");
    }
  }, {
    key: "logout",
    value: function logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('custCenter');
      localStorage.removeItem('authorities');
      localStorage.removeItem('user_name');
    }
  }, {
    key: "premitionAll",
    value: function () {
      var _premitionAll = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(userName) {
        var _yield$UserPermission, data, authorities, containAuthorities, index, _containAuthorities, _index, _containAuthorities2, _index2, _containAuthorities3, _index3, _containAuthorities4, _index4, _containAuthorities5, _index5, _containAuthorities6, _index6, _containAuthorities7, _index7, _containAuthorities8, _index8, _containAuthorities9, _index9, _containAuthorities0, _index0, _containAuthorities1, _index1, _containAuthorities10, _index10, _containAuthorities11, _index11, _t;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return UserPermissionsService.getUserPermissions(userName);
            case 1:
              _yield$UserPermission = _context.sent;
              data = _yield$UserPermission.data;
              authorities = JSON.parse(localStorage.getItem('authorities'));
              if (data[0].executeScript === "T") {
                containAuthorities = authorities.includes("ROLE_EXECUTESCRIPT");
                if (!containAuthorities) {
                  authorities.push("ROLE_EXECUTESCRIPT");
                }
              } else {
                index = authorities.indexOf("ROLE_EXECUTESCRIPT");
                if (index !== -1) {
                  authorities.splice(index, 1);
                }
              }
              if (data[0].permitirPlanilha === "T") {
                _containAuthorities = authorities.includes("ROLE_PERMITIRPLANILHA");
                if (!_containAuthorities) {
                  authorities.push("ROLE_PERMITIRPLANILHA");
                }
              } else {
                _index = authorities.indexOf("ROLE_PERMITIRPLANILHA");
                if (_index !== -1) {
                  authorities.splice(_index, 1);
                }
              }
              if (data[0].includeRules === "T") {
                _containAuthorities2 = authorities.includes("ROLE_INCLUDERULES");
                if (!_containAuthorities2) {
                  authorities.push("ROLE_INCLUDERULES");
                }
              } else {
                _index2 = authorities.indexOf("ROLE_INCLUDERULES");
                if (_index2 !== -1) {
                  authorities.splice(_index2, 1);
                }
              }
              if (data[0].viewRules === "T") {
                _containAuthorities3 = authorities.includes("ROLE_VIEWRULES");
                if (!_containAuthorities3) {
                  authorities.push("ROLE_VIEWRULES");
                }
              } else {
                _index3 = authorities.indexOf("ROLE_VIEWRULES");
                if (_index3 !== -1) {
                  authorities.splice(_index3, 1);
                }
              }
              if (data[0].deleteRules === "T") {
                _containAuthorities4 = authorities.includes("ROLE_DELETERULES");
                if (!_containAuthorities4) {
                  authorities.push("ROLE_DELETERULES");
                }
              } else {
                _index4 = authorities.indexOf("ROLE_DELETERULES");
                if (_index4 !== -1) {
                  authorities.splice(_index4, 1);
                }
              }
              if (data[0].configLayout === "T") {
                _containAuthorities5 = authorities.includes("ROLE_CONFIGLAYOUT");
                if (!_containAuthorities5) {
                  authorities.push("ROLE_CONFIGLAYOUT");
                }
              } else {
                _index5 = authorities.indexOf("ROLE_CONFIGLAYOUT");
                if (_index5 !== -1) {
                  authorities.splice(_index5, 1);
                }
              }
              if (data[0].alterLayout === "T") {
                _containAuthorities6 = authorities.includes("ROLE_ALTERLAYOUT");
                if (!_containAuthorities6) {
                  authorities.push("ROLE_ALTERLAYOUT");
                }
              } else {
                _index6 = authorities.indexOf("ROLE_ALTERLAYOUT");
                if (_index6 !== -1) {
                  authorities.splice(_index6, 1);
                }
              }
              if (data[0].viewLayout === "T") {
                _containAuthorities7 = authorities.includes("ROLE_VIEWLAYOUT");
                if (!_containAuthorities7) {
                  authorities.push("ROLE_VIEWLAYOUT");
                }
              } else {
                _index7 = authorities.indexOf("ROLE_VIEWLAYOUT");
                if (_index7 !== -1) {
                  authorities.splice(_index7, 1);
                }
              }
              if (data[0].dataExport === "T") {
                _containAuthorities8 = authorities.includes("ROLE_DATAEXPORT");
                if (!_containAuthorities8) {
                  authorities.push("ROLE_DATAEXPORT");
                }
              } else {
                _index8 = authorities.indexOf("ROLE_DATAEXPORT");
                if (_index8 !== -1) {
                  authorities.splice(_index8, 1);
                }
              }
              if (data[0].alterScript === "T") {
                _containAuthorities9 = authorities.includes("ROLE_ALTERSCRIPT");
                if (!_containAuthorities9) {
                  authorities.push("ROLE_ALTERSCRIPT");
                }
              } else {
                _index9 = authorities.indexOf("ROLE_ALTERSCRIPT");
                if (_index9 !== -1) {
                  authorities.splice(_index9, 1);
                }
              }
              if (data[0].includeScript === "T") {
                _containAuthorities0 = authorities.includes("ROLE_INCLUDESCRIPT");
                if (!_containAuthorities0) {
                  authorities.push("ROLE_INCLUDESCRIPT");
                }
              } else {
                _index0 = authorities.indexOf("ROLE_INCLUDESCRIPT");
                if (_index0 !== -1) {
                  authorities.splice(_index0, 1);
                }
              }
              if (data[0].alterLancamento === "T") {
                _containAuthorities1 = authorities.includes("ROLE_ALTERLANCAMENTO");
                if (!_containAuthorities1) {
                  authorities.push("ROLE_ALTERLANCAMENTO");
                }
              } else {
                _index1 = authorities.indexOf("ROLE_ALTERLANCAMENTO");
                if (_index1 !== -1) {
                  authorities.splice(_index1, 1);
                }
              }
              if (data[0].insertLancamento === "T") {
                _containAuthorities10 = authorities.includes("ROLE_INSERTLANCAMENTO");
                if (!_containAuthorities10) {
                  authorities.push("ROLE_INSERTLANCAMENTO");
                }
              } else {
                _index10 = authorities.indexOf("ROLE_INSERTLANCAMENTO");
                if (_index10 !== -1) {
                  authorities.splice(_index10, 1);
                }
              }
              if (data[0].deleteLancamento === "T") {
                _containAuthorities11 = authorities.includes("ROLE_DELETELANCAMENTO");
                if (!_containAuthorities11) {
                  authorities.push("ROLE_DELETELANCAMENTO");
                }
              } else {
                _index11 = authorities.indexOf("ROLE_DELETELANCAMENTO");
                if (_index11 !== -1) {
                  authorities.splice(_index11, 1);
                }
              }
              localStorage.setItem('authorities', JSON.stringify(authorities));
              return _context.abrupt("return", authorities);
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              throw new Error("Error ao verificar permissões de usuário");
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 2]]);
      }));
      function premitionAll(_x) {
        return _premitionAll.apply(this, arguments);
      }
      return premitionAll;
    }()
  }]);
}();
export default new AuthService();